import React from 'react';
import './Head.css';
import { Carousel } from 'react-bootstrap';
import { Button as BootstrapButton } from 'react-bootstrap';
import Pmy from "../../assets/images/pmy.png"
import Font5 from '../../assets/images/font5.png'
import Sbb from '../../assets/images/sbb.png'
import { Fade } from "react-awesome-reveal";
import 'animate.css';
const Button = (props) => {
  return (
    <BootstrapButton
      {...props}
      className={`button-52 ${props.className}`}
    />
  );
};

const Head = () =>{
  return (
    <div className='container-fluid header'>
      <div className='container'>
        <div className='d-flex flex-column flex-md-row'>
          <div className='d-flex flex-column col-md-6 justify-content-start'>
            <h2 className='fw-bold mt-5 mb-5' style={{color:'white', fontSize:35, lineHeight:1.6}}>NOUS SOMMES VOTRE MEILLEUR PARTENAIRE DANS LA CROISSANCE DE VOTRE BUSINESS SUR INTERNET.</h2>
            <h6 style={{color:'white', lineHeight:1.5}} className='mt-5'>
            Rejoignez les milliers d’utilisateurs qui nous font confiance et qui chaque jour utilisent nos solutions : Paiement en ligne, PoS Mobile, Shop E-Commerce, Pages de Paiement et d’Abonnement, et bien plus encore !!!
            </h6>
            <div className='button d-flex flex-row justify-content-around p-3 fw-bold btn-block mx-auto mb-3 mb-md-0 mt-5'
              style={{
                fontSize: '1rem',
                maxWidth: '100%',
                width: '250px',
                margin: '0 auto',
              }}>
              <a href='https://accounts.netikash.com' target='_blank' style={{textDecoration:'none', color:'white'}}>COMMENCEZ PAR ICI!</a>
            </div>
          </div>
          <div className='col-md-6 d-flex align-items-center'>
          <Carousel interval={2000} controls={false} indicators={false} className='w-100'>
              <Carousel.Item>
              <Fade>
                <img
                  className="d-block w-75"
                  src={Pmy}
                  alt="First slide"
                />
                </Fade>
              </Carousel.Item>
              <Carousel.Item>
                <Fade>
                <img
                  className="d-block w-75"
                  src={Font5}
                  alt="Second slide"
                />
                </Fade>
              </Carousel.Item>
              <Carousel.Item>
                  <Fade>
                      <img
                          className="d-block w-75"
                          src={Sbb}
                          alt="Second slide"
                      />
                  </Fade>
              </Carousel.Item>
          </Carousel>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Head;